import i18next from "../../i18n";
import { CompanyContactType, FileType } from "../../types";

/**
 * Pure display-formatting helpers extracted out of the pre-Carbon `CompanyProfile.tsx` (Task 6,
 * Profile/Company flow) so they're testable without rendering. Behaviour is carried over
 * unchanged from the original if/else chain and switch — only the shape changed (switch instead
 * of if/else) for readability; every case below still resolves to the exact same key.
 */

/** Label for a company file's `type`, used on the Overview/Files/Company-Data tabs' file badges. */
export const fileText = (type: FileType): string => {
  switch (type) {
    case FileType.ATTACHMENT:
      return i18next.t("tenders.form.additionalDocument");
    case FileType.SHEET:
      return i18next.t("tenders.form.plication");
    case FileType.CERTIFICATION:
      return i18next.t("tenders.form.certificate");
    case FileType.BRIEF:
      return i18next.t("tenders.form.brief");
    case FileType.SERVICE_PLACE:
      return i18next.t("tenders.form.servicePlace");
    case FileType.PRODUCT_CATALOG:
      return i18next.t("companyProfile.productsCatalog");
    case FileType.COMPANY_PRESENTATION:
      return i18next.t("companyProfile.brief");
    default:
      return i18next.t("cta.download");
  }
};

/** Label for a company contact's `type`, used on the Contacts tab's type badge. */
export const getContactTypeLabel = (
  type: CompanyContactType | "",
  t: (key: string) => string
): string => {
  switch (type) {
    case CompanyContactType.FINANCIAL:
      return t("companyProfile.financialContact");
    case CompanyContactType.QUALITY:
      return t("companyProfile.qualityContact");
    case CompanyContactType.LEGAL_REPRESENTATIVE:
      return t("companyProfile.legalRepresentative");
    default:
      return t("companyProfile.contact");
  }
};
